<template>
  <dashboard-management
    :get-types="api.getTypes"
    :get-all-posts="api.getAllPosts"
    :get-applications="api.getApplications"
    :get-modules="api.getModules"
    :get-links="api.getLinks"
    :mark-messages="api.markMessages"
    :change-post-status="api.changePostStatus"
    :change-post-priority="api.changePostPriority"
    :update-participant-workshop-status="api.updateParticipantWorkshopStatus"
    :get-guides="api.getGuides"
    :get-videos="api.getVideos"
    :get-document="api.getDocument"
    :application-id="applicationId"
  />
</template>
<script>
import DashboardManagement from '@quisit/dashboard-management';

import {
  getTypes,
  getAllPosts,
  cardsbymodule as getLinks,
  changePostStatus,
  changePostPriority,
  updateParticipantWorkshopStatus,
  getVideos,
  getGuides,
  getDocument,
} from '@/services/operations/dashboard-management';
import { getApplications, getModules } from '@/modules/common/code.api.js';
import dashbordApi from '@/modules/dashboard/api';
import applications from '@/utils/constants/applications';
export default {
  name: 'DashboardMaintenance',
  components: { DashboardManagement },
  computed: {
    applicationId() {
      return applications.Mipe;
    },
    api() {
      return Object.freeze({
        getTypes,
        getAllPosts,
        getApplications,
        getModules,
        getLinks,
        changePostStatus,
        changePostPriority,
        updateParticipantWorkshopStatus,
        markMessages: dashbordApi.markMessages,
        getGuides: getGuides,
        getVideos: getVideos,
        getDocument: getDocument,
      });
    },
  },
};
</script>
<style scoped></style>
